import React, { useContext, useEffect, useState } from 'react';
import GlobalStyle from '../../../../styles/GlobalStyle/global';

import * as S from './style';
import { ThemeProvider } from 'styled-components';
import Loading from '../../../common/Loading';
import { Outlet } from 'react-router-dom';
import { Footer, SideBar, Header, Main } from '../components';
import LoginAs from '../components/LoginAs';
import { common } from '../../../../styles/GlobalStyle/themes';
import { Box } from '@mui/material';

import {
  INewStudentProvider,
  NewStudentProviderContext,
  themes,
} from '../../ProviderNewStudent';
import { nodeEnv } from '../../../../variables';
import ChatFloating from '../components/ChatFloating';

export default function LayoutMainNewStudent() {
  const {
    accessedAs,
    student,
    loading,
    isSidebarOpen,
    themeSelected,
    setThemeSelected,
    fontSizeSelected,
    setFontSizeSelected,
  } = useContext(NewStudentProviderContext) as INewStudentProvider;

  const [isAccessibilityOpen, setIsAccessibilityOpen] =
    useState<boolean>(false);

  useEffect(() => {
    if (
      student?.preferences.theme &&
      student?.preferences.theme !== themeSelected
    ) {
      setThemeSelected(student?.preferences.theme);
    }
    if (
      student?.preferences.theme &&
      student?.preferences.fontSize !== fontSizeSelected
    ) {
      setFontSizeSelected(student?.preferences.fontSize);
    }
  }, [student?.preferences.theme, student?.preferences.fontSize]);

  return (
    <ThemeProvider
      theme={{ ...common, ...themes[themeSelected], fontSizeType: fontSizeSelected }}
    >
      {loading && <Loading />}
      {accessedAs && <LoginAs />}

      <GlobalStyle />
      <S.Container>
        <S.Main className="main">
          <SideBar setIsAccessibilityOpen={setIsAccessibilityOpen} />
          <Box
            sx={{
              display: isSidebarOpen ? 'none' : 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100%',
            }}
          >
            <Header
              fontSizeSelected={fontSizeSelected}
              setFontSizeSelected={setFontSizeSelected}
              themeSelected={themeSelected}
              setThemeSelected={setThemeSelected}
              setOpen={setIsAccessibilityOpen}
              open={isAccessibilityOpen}
            />
            <Main>
              <Outlet />
            </Main>
          </Box>
        </S.Main>
        <Footer />
      </S.Container>

      {nodeEnv === 'production' && <ChatFloating student={true} />}
    </ThemeProvider>
  );
}
